/**
 * The header search bar classifies every query (api/classify-intent) and sends
 * anything but `product-search` to the page-question chat, which only knows
 * the products on the page the shopper is on.
 *
 * A comparison or a recommendation about products that are NOT on this page is
 * a general shopping question — "difference between the iPad Pro and the Air"
 * asked from a hiking-backpack page. Those go to the discussion, which answers
 * it (with its comparison card) and anchors the shelf on the named products.
 * A comparison OF this page's products (`shouldUsePageContext: true`) stays a
 * page question.
 */
export function normalizeClassifiedIntent<T extends { intent?: string; shouldUsePageContext?: boolean }>(
  classification: T,
): T {
  if (
    (classification?.intent === 'comparison' || classification?.intent === 'recommendation') &&
    classification.shouldUsePageContext === false
  ) {
    return { ...classification, intent: 'product-search' };
  }
  return classification;
}
